module.exports = __webpack_public_path__ + "697f9764cdf4a7d418c3506d30d42881.png";